// extracted by mini-css-extract-plugin
export var currencyInput = "_n2-1";
export var currencySymbol = "_n2-0";